<template>
    <div class="rv-create p-0">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Đăng tin rao vặt
        </div>
        <div :class="{
                'body': true,
                'p-3': $detect == 'web'
            }">
            <imageCreate
                :data.sync="form.data_gallery"
                :pictureMain.sync="form.picture1"
                :error.sync="error.data_gallery"
                :errorPicture.sync="error.picture1"/>
            <titleCreate
                :data.sync="form.name"
                :error.sync="error.name"/>
            <category
                :suggest="suggestCategory"
                :data.sync="form.category"
                :error.sync="error.category"
                :title="form.name"/>
            <addressCreate
                :data.sync="form.poster_address"
                :error.sync="error.poster_address"/>
            <city
                :data.sync="form.city"
                :error.sync="error.city"/>
            <priceCreate :data.sync="form.price"/>
            <typeCreate :data.sync="form.type"/>
            <newOld :data.sync="form.new_old"/>
            <postName
                :data.sync="form.poster_name"
                :error.sync="error.poster_name"/>
            <postPhone
                :data.sync="form.poster_phone"
                :error.sync="error.poster_phone"/>
            <div class="mt-4 content">
                <p class="mb-2 fs-14px">Nội dung:</p>
                <editor :content.sync="form.description"/>
                <p class="mb-0 fs-14px text-note-img mt-1">* Nhập nội dung đầy đủ, đa dạng thì bài đăng sẽ xuất hiện ở nhiều công cụ tìm kiếm và người dùng dễ dàng tiếp cận hơn.</p>
                <div class="text-danger fs-12px mt-1" v-if="error.description">{{error.description}}</div>
            </div>
            <div style="height: 80px;" v-if="$detect == 'mobile'"></div>
            <div :class="{
                    'confirm mt-4 text-center': true,
                    'p-3 confirm-mobile fixed-bottom bg-white': $detect == 'mobile'
                }">
                <button type="button" class="btn btn-primary"
                    :disabled="loading" @click="submit()">Đăng tin</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        category: () => import('@/components/profile/create/category.vue'),
        city: () => import('@/components/profile/create/city.vue'),
        editor: () => import('@/components/editor/index'),
        imageCreate: () => import('@/components/profile/create/image'),
        titleCreate: () => import('@/components/profile/create/title'),
        addressCreate: () => import('@/components/profile/create/address'),
        priceCreate: () => import('@/components/profile/create/price'),
        postName: () => import('@/components/profile/create/postName'),
        postPhone: () => import('@/components/profile/create/postPhone'),
        typeCreate: () => import('@/components/profile/create/type'),
        newOld: () => import('@/components/profile/create/newOld'),
    },
    data() {
        return {
            imgPrimary: false,
            form: {
                name: '',
                category: '',
                description: '',
                poster_name: '',
                poster_address: '',
                poster_phone: '',
                city: '',
                type: '',
                price: '',
                new_old: '',
                picture1: '',
                data_gallery: [],
            },
            error: {},
            suggestCategory: [],
            loading: false,
        }
    },
    created() {
        apiGet('/v2/profile/raovat/suggest_create').then(res => {
            let data = res.data;
            this.form.new_old = data.new_old;
            this.form.poster_address = data.poster_address;
            this.form.poster_name = data.poster_name;
            this.form.poster_phone = data.poster_phone;
            this.form.type = data.type;
            this.form.city = data.city !== '' ? data.city : 0;
            this.suggestCategory = data.category;
        });
        if(this.$route.query.pId != null) {
            apiGet('/v2/products/get_data_product', {
                id: this.$route.query.pId
            }).then(res => {
                this.form.name = res.data.name ? res.data.name : '';
                this.form.price = res.data.price_check ? res.data.price_check : '';
                this.form.description = res.data.description ? res.data.description : '';
                this.form.data_gallery = res.data.data_picture ? res.data.data_picture : '';
            }).catch(err => {
                if(err.status == 410) {
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    this.$router.push({
                        name: 'raovat-create',
                    });
                }
            })
        }

    },
    methods: {
        async submit(){
            if(this.loading) return;
            this.loading = true;
            this.error = {};
            let form = {};
            form.name = this.form.name;
            form.category = this.form.category;
            form.description = this.form.description;
            form.poster_name = this.form.poster_name;
            form.poster_address = this.form.poster_address;
            form.poster_phone = this.form.poster_phone;
            form.list_country = [this.form.city];
            form.type = this.form.type;
            form.price = this.$stringToNumber(this.form.price);
            form.new_old = this.form.new_old;
            if(this.form.picture1){
                form.picture1 = this.form.picture1;
            }else{
                if(this.form.data_gallery.length > 0){
                    form.picture1 = this.form.data_gallery[0].filename;
                }
            }
            form.data_gallery = [];
            this.form.data_gallery.map(item => {
                form.data_gallery.push({
                    name: item.filename || item.picture,
                    width: item.width,
                    height: item.height
                });
            });
            await apiPost('/v2/raovat', form).then(res => {
                if(res.success == 1){
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                    this.$router.push({
                        name: 'raovat-update',
                        params: {
                            id: res.data.id
                        }
                    })
                }else{
                    this.$message({
                        type: 'error',
                        message: res.message,
                        center: true,
                    });
                }
            }).catch(err => {
                if(err.status == 422){
                    this.error = err.data;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            });
            this.loading = false;
        }
    }
}
</script>
<style lang="scss">
    input {
        box-shadow: none !important;
        -webkit-appearance: none !important;
    }
    .rv-create {
        .body {
            .confirm {
                button {
                    padding: 8px 60px !important;
                }
            }
            .confirm-mobile {
                box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -2px 4px rgba(0,0,0,0.12);
                button {
                    width: 100%;
                }
            }
        }
    }
    .rv-valiadate-input-form {
        input {
            border: 1px solid #dc3545 !important;
        }
        label {
            color: #dc3545 !important;
        }
    }
    .input-focus-effect {
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        input {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
            &:focus {
                border-color: #007bff;
            }
            &:focus + label {
                transform: translateY(0);
                top: -13px;
                color: #007bff;
                background: #fff;
                padding: 0 10px;
                font-size: 14px;
                margin-left: -5px;
            }
        }
        label {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            pointer-events: none;
            color: #999;
            transition: 0.15s linear;
            font-size: 16px;
        }
        .input-on-alue {
            transform: translateY(0) !important;
            top: -13px !important;
            color: #007bff !important;
            background: #fff !important;
            padding: 0 10px !important;
            font-size: 14px !important;
            margin-left: -5px !important;
        }
    }
</style>
